import { I18n } from '@calendly/i18n';
import { Loader } from '@calendly/ui/components/loader';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { ORGANIZATION_MEMBERSHIP_ROLES } from 'constants/organization_roles';
import { MenuItemInfo } from './menu_item_info';
import { suggestionType } from './prop-types';
import { RemoveOrgAdminCheckbox } from './remove_org_admin_checkbox';
const wrapperCss = "w1vqfna1";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'ul';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const suggestionWrapperCss = "s16j68yy";
const SuggestionWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'li';
  return <Component ref={ref} {...restProps} className={classNames(suggestionWrapperCss, props.className)} />;
});
const suggestionCss = "sgohbia";
const Suggestion = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(suggestionCss, props.className)} />;
});
const removeContainerCss = "rrhfjhp";
const RemoveContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(removeContainerCss, props.className)} />;
});
export const SelectedSuggestions = ({
  suggestions,
  onRemove,
  onChange,
  isLoading,
  isSuggestionRemovable = () => true,
  isSuggestionDisabled = () => false,
  showUserRole,
  showOrgAdminRemoval
}) => <Wrapper>
    {isLoading && <Loader data-testid="loader" />}
    {suggestions.map(suggestion => <SuggestionWrapper key={suggestion.id}>
        <Suggestion>
          <MenuItemInfo suggestion={suggestion} showUserRole={showUserRole} />
          {isSuggestionRemovable(suggestion.type, suggestion.entity) && <RemoveContainer>
              <MinimalButton onClick={() => onRemove(suggestion)} disabled={isSuggestionDisabled(suggestion.type, suggestion.entity)} title={I18n.t('publisher.action.remove')} size="small">
                {I18n.t('publisher.action.remove')}
              </MinimalButton>
            </RemoveContainer>}
        </Suggestion>
        {showOrgAdminRemoval && suggestion.entity.role === ORGANIZATION_MEMBERSHIP_ROLES.ADMIN && <RemoveOrgAdminCheckbox onChange={onChange} suggestion={suggestion} />}
      </SuggestionWrapper>)}
  </Wrapper>;
SelectedSuggestions.propTypes = {
  suggestions: PropTypes.arrayOf(suggestionType).isRequired,
  onRemove: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  showUserRole: PropTypes.bool,
  showOrgAdminRemoval: PropTypes.bool,
  isSuggestionRemovable: PropTypes.func,
  isSuggestionDisabled: PropTypes.func
};

require("./selected_suggestions.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./selected_suggestions.js");